import {
  Card,
  CardContent,
  CardMedia,
  Container,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import React from "react";
import { appdata } from "../models/appdata";

const GridPart = () => {
  return (
    <Container>
      <Typography
        variant="h5"
        color="primary"
        sx={{ fontWeight: "bold", textAlign: "center", p: 2, mt: 4 }}
      >
        Kenapa Menggunakan Jasa Layanan GEDE PARI TRANS
      </Typography>
      <Grid container spacing={2}>
        {appdata.whyUs.map((v, i) => (
          <MyItem key={i} data={v} />
        ))}
      </Grid>
    </Container>
  );
};

export default GridPart;

const MyItem = ({ data }) => (
  <Grid item xs={12} sm={6} md={4}>
    <Card>
      <CardMedia component="img" height="200" image={data.image} alt="gambar" />
      <CardContent>
        <Typography
          gutterBottom
          variant="subtitle2"
          component="h6"
          sx={{ textAlign: "center" }}
        >
          {data.judul}
        </Typography>
        <Typography
          gutterBottom
          variant="body2"
          component="p"
          sx={{ height: 120, overflow: "scroll" }}
        >
          {data.isi}
        </Typography>
      </CardContent>
    </Card>
  </Grid>
);
